// extracted by mini-css-extract-plugin
export var centerText = "_5m-8";
export var container = "_5m-0";
export var doughnutContainer = "_5m-7";
export var legend = "_5m-a";
export var legendItemColorDisplay = "_5m-b";
export var legendItemLabel = "_5m-d";
export var legendItemValue = "_5m-c";
export var lg = "_5m-5";
export var maxWidth = "_5m-9";
export var md = "_5m-4";
export var responsive = "_5m-6";
export var sm = "_5m-3";
export var xs = "_5m-2";
export var xxs = "_5m-1";